import React, { useEffect, useState } from "react";
import { Carousel } from "react-bootstrap";
import { Popup } from "../../../../library/popup";
import { useSelector, useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";
import StepsView from "./steps-view";
import DetailsConfiguration from "./details-container";
import DNSConfiguration from "./dns-container";
import GetStartedContainer from "./get-started-container";
import { TransparentButton, SolidButton } from "../../../../library/button";
import {
  changeCampaignsModal,
  requestDomainAuthentication,
  requestDomainVerification,
  resetDomainAuthentication,
  resetDomainVerification,
} from "../../../../../redux/actions/campaigns";
import { sendErrorNotification } from "../../../../universal/notifications/notifications";
import "./style.scss";

const Index = () => {
  const dispatch = useDispatch();

  const modalState = useSelector(
    (state) => state.campaigns.showModals.verifyDomainModal
  );

  const companyId = useSelector(
    (state) =>
      state &&
      state.activeCompany &&
      state.activeCompany.activeCompany &&
      state.activeCompany.activeCompany.id
  );
  const activeChannel = useSelector((state) => state.campaigns.activeChannel);

  const allContactLists = useSelector(
    (state) => state.campaigns.fetchDistributionSelections.data.contactLists
  );
  const allTemplates = useSelector(
    (state) => state.campaigns.fetchDistributionSelections.data.templates
  );

  const [stepProgress, setStepProgress] = useState(0);

  const [verificationDetails, setVerificationDetails] = useState({
    domain: null,
  });

  const authenticationStatus = useSelector(
    (state) => state.campaigns.initializeDomain.authentication.status
  );
  const authenticationError = useSelector(
    (state) => state.campaigns.initializeDomain.authentication.error
  );
  const authenticationLoading = useSelector(
    (state) => state.campaigns.initializeDomain.authentication.loading
  );
  const authenticationDetails = useSelector(
    (state) => state.campaigns.initializeDomain.authentication.details
  );

  const verificationLoading = useSelector(
    (state) => state.campaigns.initializeDomain.verification.loading
  );
  const verificationStatus = useSelector(
    (state) => state.campaigns.initializeDomain.verification.status
  );
  const verificationError = useSelector(
    (state) => state.campaigns.initializeDomain.verification.error
  );

  const handleClose = () => {
    dispatch(changeCampaignsModal({ verifyDomainModal: false }));
  };

  const clickNextSlide = () => {
    switch (stepProgress) {
      case 0:
        if (verificationDetails.domain) {
          dispatch(
            requestDomainAuthentication({
              domain: verificationDetails.domain,
              username: activeChannel.username,
              companyId: companyId,
              channelId: activeChannel.id,
            })
          );
        } else {
          sendErrorNotification("Vennligst fyll inn domene og subdomene.");
        }
        break;
      case 1:
        if (authenticationDetails && authenticationDetails.id) {
          dispatch(
            requestDomainVerification({
              id: authenticationDetails.id,
              username: activeChannel.username,
            })
          );
        } else {
          sendErrorNotification("Kunne ikke gå videre.");
        }
        break;
      default:
        break;
    }
  };

  const renderVerificationProgress = () => {
    switch (stepProgress) {
      case 0:
        return 5;
      case 1:
        return 50;
      case 2:
        return 100;
      default:
        return 5;
    }
  };

  useEffect(() => {
    if (authenticationStatus && authenticationStatus === "success") {
      setStepProgress(1);
    }
  }, [authenticationStatus]);

  useEffect(() => {
    if (verificationStatus && verificationStatus === "success") {
      setStepProgress(2);
    }
  }, [verificationStatus]);

  useEffect(() => {
    if (authenticationError) {
      sendErrorNotification("Kunne ikke verifisere domenet.");
    }
  }, [authenticationError]);

  const renderNextButton = () => {
    if (authenticationLoading) {
      return (
        <SolidButton
          disabled={true}
          color="blue"
          icon={<i className="fas fa-circle-notch fa-spin"></i>}
          title="Henter data.."
          type="button"
        />
      );
    }
    if (verificationLoading) {
      return (
        <SolidButton
          disabled={true}
          color="blue"
          icon={<i className="fas fa-circle-notch fa-spin"></i>}
          title="Verifiserer"
          type="button"
        />
      );
    }
    if (stepProgress === 2 && verificationStatus) {
      return (
        <SolidButton
          onClick={() => handleClose()}
          color="blue"
          title="Kom i gang"
          type="button"
        />
      );
    }
    return (
      <SolidButton
        onClick={() => clickNextSlide()}
        color="blue"
        title="Gå videre"
        type="button"
      />
    );
  };

  useEffect(() => {
    dispatch(resetDomainAuthentication());
    dispatch(resetDomainVerification());
    setStepProgress(0);
    setVerificationDetails({
      domain: null,
      subdomain: null,
    });
  }, []);

  return (
    <Popup
      onClose={handleClose}
      show={modalState}
      title="Sett opp og verifiser domene"
      description="Følg instruksjonene vist under for å laste opp en CSV-fil og konfigurere riktig datasett."
      buttons={[
        <TransparentButton
          title="Avbryt"
          id="closeButtonAdd"
          type="button"
          data-dismiss="modal"
          onClick={() => handleClose()}
        />,
        renderNextButton(),
      ]}
    >
      <div className="verify-domain-content-container">
        <StepsView
          stepProgress={stepProgress}
          renderVerificationProgress={renderVerificationProgress}
        />
        <div className="modal-content-container">
          <Carousel
            activeIndex={stepProgress}
            indicators={false}
            controls={false}
          >
            <Carousel.Item className="selection-item">
              <DetailsConfiguration
                verificationDetails={verificationDetails}
                setVerificationDetails={setVerificationDetails}
              />
            </Carousel.Item>
            <Carousel.Item className="selection-item">
              <DNSConfiguration details={authenticationDetails} />
            </Carousel.Item>
            <Carousel.Item className="selection-item">
              <GetStartedContainer />
            </Carousel.Item>
          </Carousel>
        </div>
      </div>
      <ToastContainer />
    </Popup>
  );
};

export default Index;
